module.exports = __webpack_public_path__ + "static/img/cinema-15.06309e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-15.png
// module id = 1382
// module chunks = 4